import React from 'react';

import Footer from '@aetn/ui-standard/Footer/Footer';
import * as brandMenu from '@aetn/ui-standard/Footer/Footer.menu';

const config = {
  brand: 'history',
  brandName: 'HISTORY',
  origin: 'https://www.history.com',
  social: {
    facebook: 'History',
    facebookAdmin: '100001148659782',
    facebookAppId: '125536057474924',
    twitter: 'history',
    twitterAppId: 'History',
    youtube: 'history',
    instagram: 'history',
  },
};

const menu = brandMenu[config.brand](config.brand);

const PageFooter = () => {
  return (
    <Footer
      brand={config.brand}
      brandName={config.brandName}
      origin={config.origin}
      menu={menu}
      socials={{
        facebook: { id: config.social.facebook },
        twitter: { id: `@${config.social.twitter}` },
        youtube: { id: config.social.youtube },
        instagram: { id: config.social.instagram },
      }}
    />
  );
};

export default PageFooter;
